import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export const fetchActiveLocation = createAsyncThunk(
  "location/fetchActiveLocation",
  async (dbCode, { rejectWithValue }) => {
    try {
      if (!dbCode) return rejectWithValue("No dbCode provided");
      const response = await axios.get(`${apiBaseUrl}/otherregistration/getoptions/${dbCode}`);
      const records = response.data || [];
      const locationRecords = records.filter(
        (r) => String(r.Type || r.type || "").toLowerCase() === "location"
      );
      if (locationRecords.length === 0) return rejectWithValue("No locations found");

      const savedLocName = sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation") || "";
      const savedLocId = Number(sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId") || 0);

      let matched = null;
      if (savedLocId > 0) {
        matched = locationRecords.find((l) => Number(l.Auto ?? l.auto ?? 0) === savedLocId);
      }
      if (!matched && savedLocName) {
        matched = locationRecords.find(
          (l) => (l.Name || l.name || "").trim().toLowerCase() === savedLocName.trim().toLowerCase()
        );
      }
      if (!matched) {
        matched = locationRecords[0];
      }

      const id = Number(matched.Auto ?? matched.auto ?? 0);
      const name = matched.Name || matched.name || "SHOP";

      try {
        if (id > 0) {
          sessionStorage.setItem("loginLocationId", String(id));
          localStorage.setItem("loginLocationId", String(id));
        }
        if (name) {
          sessionStorage.setItem("loginLocation", name);
          localStorage.setItem("loginLocation", name);
        }
      } catch (_) {}

      return { id, name };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const getInitialActiveLocation = () => {
  try {
    const rawLocId = sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId");
    const locName = sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation");
    const locId = Number(rawLocId);
    if (!isNaN(locId) && locId > 0) {
      return {
        id: locId,
        name: locName || "SHOP",
      };
    }
  } catch (e) {
    console.error("Error reading stored location:", e);
  }
  return {
    id: 0,
    name: "SHOP",
  };
};

const initialState = {
  activeLocation: getInitialActiveLocation(),
  loading: false,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setActiveLocation: (state, action) => {
      if (action.payload) {
        const idVal = Number(action.payload.id ?? action.payload.Auto ?? action.payload.auto ?? 0);
        const nameVal = action.payload.name || action.payload.Name || "SHOP";
        state.activeLocation = {
          id: idVal,
          name: nameVal,
        };
        try {
          if (idVal > 0) {
            sessionStorage.setItem("loginLocationId", String(idVal));
            localStorage.setItem("loginLocationId", String(idVal));
          }
          if (nameVal) {
            sessionStorage.setItem("loginLocation", nameVal);
            localStorage.setItem("loginLocation", nameVal);
          }
        } catch (_) {}
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActiveLocation.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.id > 0) {
          state.activeLocation = action.payload;
        }
      })
      .addCase(fetchActiveLocation.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setActiveLocation } = locationSlice.actions;

export const selectActiveLocation = (state) => state.location?.activeLocation;
export const selectActiveLocationId = (state) => state.location?.activeLocation?.id || 0;

export default locationSlice.reducer;
